// Semáforo de adoção usado em todo o dashboard:
// acima de 70% verde, entre 40% e 70% amarelo, abaixo de 40% vermelho.
export const ADOPTION_COLORS = {
  good: "#16A34A",
  warning: "#EAB308",
  bad: "#DC2626",
};

export const getAdoptionColor = (rate: number) => {
  if (rate > 70) return ADOPTION_COLORS.good;
  if (rate >= 40) return ADOPTION_COLORS.warning;
  return ADOPTION_COLORS.bad;
};

// 62.5 -> "62,5"
export const formatRate = (rate?: number | null) => {
  if (rate === null || rate === undefined) return "---";

  return rate.toString().replace(".", ",");
};

export const formatPercent = (rate?: number | null) => {
  if (rate === null || rate === undefined) return "---";

  return `${formatRate(rate)}%`;
};

// Delta em pontos percentuais, sempre com sinal: "+3,2 p.p."
export const formatDelta = (delta: number) => {
  const sign = delta > 0 ? "+" : "";

  return `${sign}${delta.toFixed(1).replace(".", ",")} p.p.`;
};

export const formatShortDate = (iso?: string) => {
  if (!iso) return "";

  const [year, month, day] = iso.split("-");
  if (!year || !month || !day) return iso;

  return `${day}/${month}`;
};
